import { render, staticRenderFns } from "./BCXInfoSection.vue?vue&type=template&id=77ae3bf6&scoped=true"
import script from "./BCXInfoSection.vue?vue&type=script&lang=ts"
export * from "./BCXInfoSection.vue?vue&type=script&lang=ts"
import style0 from "./BCXInfoSection.vue?vue&type=style&index=0&id=77ae3bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ae3bf6",
  null
  
)

export default component.exports